import styled from '@happymoneyinc/styled-components';
import Card from '../Card/Card.js';

const PopoverRoot = styled.div`
  position: fixed;
  inset: 0;
`;
const PopoverCard = styled(Card)`
  ${_ref => {
  let {
    style
  } = _ref;
  return style;
}} /* stylelint-disable-line CssSyntaxError */
  position: absolute;
  min-width: 16px;
  min-height: 16px;
  overflow-x: hidden;
  overflow-y: auto;
`;

export { PopoverCard, PopoverRoot };
//# sourceMappingURL=styled.js.map
